export const lisaImages = [
  {
    src: "images/choreography/CompaniaLisanormal.jpg",
    description: "Compañía Folklorica Latina(1980's)",
  },

  {
    src: "images/choreography/Grndsculpture_Piedraslrg.jpg",
    description:
      "Lisa's choreography, 'Al Ritmo de las Piedras',(Rock Dance)\n at The Grounds for Sculpture, NJ",
  },
  {
    src: "images/choreography/Sueno_Verdiales.jpg",

    description:
      "Lisa's Choreography: \"The 'Verdiales' was a powerhouse of community.\" \n(Robert Johnson, Star Ledger)",
  },
  {
    src: "images/choreography/Lisacomedypiece.jpg",
    description:
      "\"Lisa Botalico and Eva Lucena stole the show with their comedic, 'Tanguillos por Chufla'.\" \n(Damaris Solis, Flamenco Buzz)",
  },
  {
    src: "images/choreography/CarmenMedia_002.JPG",
    description: 'Roxey Ballet production of "Carmen"',
  },
  {
    src: "images/choreography/Carmen_red_shawl.jpg",
    description: 'Roxey Ballet production of "Carmen"',
  },
  {
    src: "images/choreography/CarmenMedia_018.JPG",
    description: 'Roxey Ballet production of "Carmen"',
  },

  {
    id: 27,
    src: "images/choreography/DSC_4334.JPG",
    description: '"Fire Dance" from Manuel deFalla\'s "El Amor Brujo"',
  },
  {
    id: 28,
    src: "images/choreography/DSC_0179.JPG",
    description:
      "Lisa performing with young students at Communiversity, yearly outdoor festival, Princeton, Nj",
  },
  {
    id: 29,
    src: "images/choreography/Lisa_Ramya_Co.jpg",
    description:
      "With Ramya Ramnarayan and the Ngifrithyanjali Ensemble, Crossroads Theatre",
  },
  {
    id: 30,
    src: "images/choreography/Photo-0035.jpg",
    description:
      'Willie Sanchez of NJN\'s "Images/Imagenes" and the Emmy for his documentary "The Spanish Guitar" with Lisa, featured dancer',
  },
  {
    id: 31,
    src: "images/choreography/Lisa_Ramya2.jpg",
    description:
      'With Bharathanatyam dancer Ramya Ramnarayan: "...creating an atmosphere of moonlit rapture." (Star Ledger)',
  },
  {
    id: 32,
    src: "images/choreography/Lisa MarieGrnds for Sculpture3.jpg",
    description:
      '"...en el jardin" with modern dancer Marie Alonzo at the Grounds for Sculpture, NJ',
  },
  {
    id: 33,
    src: "images/choreography/10042009_004.jpg",
    description: "Grounds for Sculpture",
  },
  {
    id: 34,
    src: "images/choreography/IMG_1028.jpg",
    description: "Lisa & Alexia (Belly Dance & Beyond)",
  },
  {
    id: 35,
    src: "images/choreography/LisaCapture__Tarantula_best.JPG",
    description:
      'Performing "Tarantula" with members of the New Brunswick Chamber Orchestra',
  },
  {
    id: 36,
    src: "images/FlamencoMoro1.jpg",
    description:
      '"Flamenco Moro", 1985: Lisa, left, with legends Maria Alba & Victorio.',
  },
  {
    id: 37,
    src: "images/choreography/FireDance.jpg",
    description:
      '"Fire Dance", choreographed by Lisa Botalico to the magnficent music of Manuel deFalla',
  },
  {
    id: 38,
    src: "images/choreography/Sueno_smll.jpg",
    description:
      '"Sueño", a Flamenco Nutcracker conceived and directed by Lisa.',
  },
  {
    id: 39,
    src: "images/Lisa and CristinaA11 cropped Nutwrk.jpg",
    description:
      'Majas from "Sueño", a Flamenco Nutcracker conceived and directed by Lisa.',
  },
  {
    id: 40,
    src: "images/choreography/lisajoel.jpg",
    description:
      'Singing "Anda Jaleo" with violist Joel Rudin and guitarist Ivan Max',
  },
  {
    id: 20,
    src: "images/choreography/BohemeOperaCarmen.jpg",
    description:
      'Lisa Botalico (choreographer), Krystina Moreno and Teresa Rodriquez of the Alborada Spanish Dance Theatre, in the Boheme Opera Company production of "Carmen"',
  },
  {
    id: 41,
    src: "images/choreography/LisaRamyaScreenshotsCombo.jpg",
    description:
      "Reunited: with Ramya Ramnarayan in virtual performance on Instagram, May, 2020",
  },
  {
    id: 51,
    src: "images/choreography/Ramya_Lisa_The HinduArticle.jpg",
    description: "Article in The Hindu, India",
  },

  {
    id: 53,
    src: "images/choreography/Robeson_Rock Dance_flail.jpg",
    description:
      "'Rock Dance' at ACP's PAUL ROBESON 126TH BIRTHDAY CELEBRATION",
  },
  {
    id: 54,
    src: "images/choreography/Zorro_Final_Dress_0251.jpg",
    description:
      "NE USA Premier of 'Zorro, the Musical' by the Gipsy Kings with PinnWorth Productions at Kelsey Theater January, 2019; Lisa Botalico, choreographer",
  },
  {
    id: 55,
    src: "images/choreography/LisaAllentown2.jpg",
    description:
      'Nov, 2025: Lisa performing her original choreography to "Fandango", guitar quintet No 4 by Boccherini, with the Allentown Chamber Players',
  },
];

export const lisaGalleryImages = [
  {
    src: "images/Classic Yellow Lisa.jpg",
    description: "Classic Image of Lisa",
  },
  {
    id: 2,
    src: "images/Lisapicin_NYTimesDec2010.jpg",
    description: 'Dancing "Garrotin" photo: NY Times',
  },
  {
    id: 3,
    src: "images/LisaClavilitos.jpg",
    description: "Singing 'Clavelitos'",
    text: "Great singng",
  },
  {
    id: 4,
    src: "images/Lisa_BilliMartitango.jpg",
    thumbnail: "images/Lisa_BilliMartitango.jpg",
    description: "Tango, with Billi Marti, 1980's",
  },
  {
    id: 11,
    src: "images/Lisa_BilliMarti_LatinHustle.jpg",
    thumbnail: "images/Lisa_BilliMarti_LatinHustle.jpg",
    description: "Latin Hustle!, 1980's, with Billi Marti",
  },
  {
    id: 6,
    src: "images/Screenshot 2024-07-14 112822.jpg",
    description:
      '"Tanguillo" with Manolo Rivera at Cami Hall, NYC, 1988. See the video on the Videos page',
  },
  {
    id: 7,
    src: "images/LisaYellowcape.jpg",
    description: "'El Relicario Pasadoble' for Morris Arts",
  },
  {
    id: 8,
    src: "images/LisaZapcostmeEdit.jpg",
    description: "Zapateado!",
  },
  {
    id: 9,
    src: "images/D7K_8201_edited-2.jpg",
    description: "Alborada Feria",
  },

  {
    id: 10,
    src: "images/Feria_GreenCostume_Irina.jpg",
    description: "Alborada Feria",
  },
  {
    id: 11,
    src: "images/Lisa_Elena_FlamencoMoro.jpg",
    description: "Flamenco Moro",
  },
  {
    id: 12,
    src: "images/Lisa_Orlando2.jpg",
    description: "with Orlando Romero",
  },
  {
    id: 13,
    src: "images/Lisa_LincolnCntrCrafts2.jpg",
    description: "Lincoln Center Outdoors (1980's)",
  },

  {
    id: 14,
    src: "images/Lisa_OrlandoRomero.jpg",
    description: "Dancing 'Guajira' with Orlando Romero",
  },
  {
    id: 15,
    src: "images/BARBIES135.jpg",
    description:
      "Dancing 'Guajiras' solo in a white suit and hat: Lisa's tribute to the late Orlando Romero",
  },
  {
    id: 16,
    src: "images/Lisa_LuisVargas.jpg",
    description: "With famed cantaor Luis Vargas",
  },
  {
    id: 17,
    src: "images/Inspiraciones.jpg",
    description: "'Inspiraciones': Stafford Theater, Manahawkin, 2021",
  },
  {
    id: 18,
    src: "images/Lisa_Botalico_castenets2023.jpg",
    description: "'Juerga Flamenco': Byron Barn, Plainsboro, 2023",
  },
  {
    id: 19,
    src: "images/Lisa_red Shawl_ACP_1.jpg",
    description: "At The Arts Council of Princeton, 2024",
  },
];
